import {Moment} from 'moment-timezone'

/**
 * function to fit elements to existing grid based on column count and colSpan for each element
 * @param columnCount a positive integer
 */
export const fitElementsToGridBasedOnColSpan = <TData>(
  columnCount: number,
  elements: {colSpan: number; data: TData}[]
) => {
  const filteredItems = elements.filter((item) => item.colSpan <= columnCount)
  const rows: {colSpan: number; data: TData}[][] = [[]]

  for (const item of filteredItems) {
    for (const row of rows) {
      const currentColSpan = row.reduce((acc, item) => acc + item.colSpan, 0)
      if (item.colSpan <= columnCount - currentColSpan) {
        row.push(item)
        break
      } else {
        rows.push([])
        continue
      }
    }
  }
  return rows.flat()
}

interface GetListOfDaysParams {
  start: Moment
  end?: Moment
  additionalDays?: number
}

export const getListOfDays = ({start, end, additionalDays}: GetListOfDaysParams): Moment[] => {
  const retList: Moment[] = []
  retList.push(start)

  if (end !== undefined) {
    const current: Moment = start.clone().add(1, 'day')

    while (current < end) {
      retList.push(current.clone())
      current.add(1, 'days')
    }
  }

  if (additionalDays && additionalDays > 0) {
    const lastInList: Moment = retList[retList.length - 1]

    for (let i = 1; i <= additionalDays; i++) {
      retList.push(lastInList.clone().add(i, 'days'))
    }
  }
  return retList
}

type RaiseError = (error: Error | null) => void
type NotifyError = (message: React.ReactNode) => void

export const notifyIfErrorMessage = (
  data: unknown,
  raiseError: RaiseError,
  notifyError: NotifyError
): void => {
  if (typeof data === 'string') notifyError(data)
  else if (data) raiseError(new Error(JSON.stringify(data)))
  // TODO: Add generic error message when no data.
}
